import './css/OverlayTheme.css';
import React, { useEffect, useRef } from 'react';
import { Modal } from 'semantic-ui-react';
import './css/CryptoMoneyPanel.css';
import './css/PasswordPrompt.css';

function PasswordPrompt(props) {
    const submitted = useRef(false);
    const spanish = props.language == 'spanish';

    useEffect(() => {
        if (props.open) submitted.current = false;
    }, [props.open]);

    function confirmPassword(event) {
        event.preventDefault();
        if (!props.value || submitted.current) return;
        submitted.current = true;
        props.onConfirm();
    }

    return (
        <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }}
            open={!!props.open}
            size="tiny"
            className={'tbp-crypto-modal tbp-password-prompt ' + (props.theme == 'light' ? 'light' : 'dark') + (props.desktop ? ' tbp-desktop-crypto-modal' : '')}
            onClose={props.onCancel}
            closeOnDimmerClick={false}
            closeOnEscape={true}
        >
            <h3>{spanish ? 'Ingresa Tu Contraseña' : 'Enter Your Password'}</h3>
            {props.message && <p className="note">{props.message}</p>}
            <form onSubmit={confirmPassword}>
                <input
                    type="password"
                    autoFocus
                    autoComplete="current-password"
                    placeholder={spanish ? 'Contraseña' : 'Password'}
                    aria-label={spanish ? 'Contraseña' : 'Password'}
                    value={props.value}
                    onChange={props.onChange}
                />
                <button type="submit" disabled={!props.value}>
                    {spanish ? 'Continuar' : 'Continue'}
                </button>
                <button type="button" className="cancel" onClick={props.onCancel}>
                    {spanish ? 'Cancelar' : 'Cancel'}
                </button>
            </form>
        </Modal>
    );
}

export default PasswordPrompt;
